import { CircularProgress, Slide } from '@mui/material'
import { useTheme } from '@mui/styles'
import CloseButton from 'common/components/CloseButton'
import {
  AddIntegrationNotification,
  MonitoringNotification,
  PriceChangeNotification,
} from 'common/components/NotificationSnackbar'
import { AlertCircle, BadgeInfo, CheckCircle, XCircle } from 'lucide-react'
import { SnackbarProvider as SnackProvider } from 'notistack'
import { forwardRef, useRef } from 'react'

const SlideTransition = forwardRef(function Transition(props, ref) {
  return <Slide ref={ref} {...props} direction="up" timeout={400} />
})

export const SnackbarProvider = ({ children }) => {
  const snackRef = useRef()
  const theme = useTheme()
  const onClickDismiss = (key) => () => {
    snackRef.current.closeSnackbar(key)
  }

  return (
    <SnackProvider
      ref={snackRef}
      maxSnack={4}
      autoHideDuration={5000}
      classes={{
        containerRoot: `${theme?.palette?.mode}-snackbar`,
      }}
      variant="primary"
      action={(key) => <CloseButton size={20} onClick={onClickDismiss(key)} aria-label="close" />}
      iconVariant={{
        success: <CheckCircle size={15} />,
        error: <XCircle size={15} />,
        warning: <AlertCircle size={15} />,
        info: <BadgeInfo size={15} />,
        loading: <CircularProgress size={15} thickness={5} color="inherit" />,
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      TransitionComponent={SlideTransition}
      Components={{
        monitoringNotification: MonitoringNotification,
        addIntegrationNotification: AddIntegrationNotification,
        priceChangeNotification: PriceChangeNotification,
      }}
      preventDuplicate
    >
      {children}
    </SnackProvider>
  )
}
